import { type ToursExEntity, apiClient } from '@/libs/api'

export type FetchTourQuery = {
  tenantKey: string
  tourId: number
}

export const fetchTour = async (
  { tenantKey, tourId }: FetchTourQuery,
  signal?: AbortSignal
): Promise<ToursExEntity> => {
  const { data } = await apiClient._tenant(tenantKey).tours._id(tourId).$get({
    config: {
      signal
    }
  })
  return data
}
